import React, {useContext, useEffect, useState} from "react";
import TrackVASContext from "../../TrackVASContext";
import {PageTitle} from "../../../_metronic/layout/core";
import {GenericTable} from "../generic/table/GenericTable";
import {defaultList} from "../generic/InitialStates";
import {UserAddEditDialog} from "./UserAddEditDialog";
import {ActionsColumnFormatter} from "../../column-formatters/ActionsColumnFormatter";
import {HeaderColumnFormatter} from "../../column-formatters/HeaderColumnFormatter";
import {ENTITY_ID_USER} from "../generic/Constants";
import {UserPasswordEditDialog} from "./UserPasswordEditDialog";
import {showConfirmDialog} from "../../generic-components/ConfirmDialog";
import {genericDelete} from "../generic/crud";
import {showToast, TOAST_SUCCESS} from "../../utils/toast/Toast";
import {AuditHistoryDialog} from "../audit-history/AuditHistoryDialog";
import {TrueFalseColumnFormatter} from "../../column-formatters/TrueFalseColumnFormatter";
import {DMSDateColumnFormatter} from "../../column-formatters/DMSDateColumnFormatter";
import {DashboardTypeColumnFormatter} from "../../column-formatters/DashboardTypeColumnFormatter";

export function UsersPage() {
    const myData = useContext(TrackVASContext);
    const [reload, setReload] = useState(1);
    const [pageLoadComplete, setPageLoadComplete] = useState(false);
    const [showModal1, setShowModal1] = useState(false);
    const [showModal2, setShowModal2] = useState(false);
    const [showAuditHistoryModal, setShowAuditHistoryModal] = useState(false);
    const [showModelId, setShowModelId] = useState(null);

    const profileBreadCrumbs = [
        {
            title: "Home",
            path: "/dashboard",
            isSeparator: false,
            isActive: false,
        },
        {
            title: "",
            path: "",
            isSeparator: true,
            isActive: false,
        },
    ];

    const columns = [
        {
            dataField: "name",
            text: "Full Name",
            search: true
        },
        {
            dataField: "id",
            text: "User Name",
            formatter: HeaderColumnFormatter
        },
        {
            dataField: "designationName",
            text: "Designation",
        },
        {
            dataField: "roleName",
            text: "Role",
            showInMobile: false,
        },
        {
            dataField: "dashboardTypeName",
            text: "Dashboard",
            formatter: DashboardTypeColumnFormatter,
            showInMobile: false,
        },
        {
            dataField: "phone",
            text: "Phone",
            showInMobile: false,
        },
        {
            dataField: "loginCount",
            text: "Login Count",
            showInMobile: false,
        },
        {
            dataField: "loginDate",
            text: "Last Login",
            formatter: DMSDateColumnFormatter,
            showInMobile: false,
        },
        {
            dataField: "active",
            text: "Active",
            formatter: TrueFalseColumnFormatter,
            showInMobile: false,
            formatExtraData: {
                data:
                    [
                        {
                            value: "true",
                            displayText: "ACTIVE",
                            color: "primary",
                        },
                        {
                            value: "false",
                            displayText: "INACTIVE",
                            color: "danger",
                        },
                    ],
            },
        },
        {
            dataField: "action",
            text: "Actions",
            headerStyle: {
                width: '180px',
            },
            formatter: ActionsColumnFormatter,
            formatExtraData: {
                buttons:
                    [
                        {
                            name: "Edit",
                            color: "primary",
                            icon: "edit",
                            method: openEditDialog
                        },
                        {
                            name: "Delete",
                            color: "danger",
                            icon: "trash-alt",
                            method: openDeleteDialog
                        },
                        {
                            name: "Change Password",
                            color: "info",
                            icon: "key",
                            method: openPasswordChangeDialog
                        }
                    ],
            },
            classes: "text-right pr-0",
            headerClasses: "text-right pr-3",
            style: {
                minWidth: "100px",
            },
        },
    ];

    function openEditDialog(row) {
        setShowModelId(row.id);
        setShowModal1(true);
    }

    function reloadData() {
        setReload(reload + 1);
    }

    async function openDeleteDialog(row) {
        const result = await showConfirmDialog("Do you really want to delete the User?");
        if (result) {
            genericDelete(ENTITY_ID_USER, row.id).then(() => {
                showToast("User is Deleted!", TOAST_SUCCESS);
                reloadData();
            }).catch(() => {
                }
            ).finally(() => {
                reloadData();
            });
        }
    }

    function openPasswordChangeDialog(row) {
        setShowModelId(row.id);
        setShowModal2(true);
    }

    function addButtonClicked() {
        setShowModelId(null);
        setShowModal1(true);
    }

    function historyButtonClicked () {
        setShowModelId(ENTITY_ID_USER);
        setShowAuditHistoryModal(true)
    }

    function handleClose() {
        setShowModal1(false);
        setShowModal2(false);
        setShowAuditHistoryModal(false)
    }

    useEffect(() => {
        myData.setBaseData({
            toolBarButtons: [
                {
                    name: "Show History",
                    color: "primary",
                    icon: "fa fa-clock",
                    onClick: historyButtonClicked,
                },
                {
                    name: "ADD USER",
                    color: "primary",
                    icon: "fa fa-plus",
                    onClick: addButtonClicked,
                },
            ],
        });

        setPageLoadComplete(true);

        return () => {
            myData.setBaseData({
                toolBarButtons: []
            });
        };
    }, []);

    return (
        <>
            <PageTitle breadcrumbs={profileBreadCrumbs}>Users</PageTitle>
            <div className="card card-body">
                {pageLoadComplete && (
                    <GenericTable
                        reload={reload}
                        defaultData={defaultList}
                        columns={columns}
                        entityId={ENTITY_ID_USER}
                    />
                )}
            </div>
            <UserAddEditDialog show={showModal1} handleClose={handleClose} id={showModelId} onSave={reloadData}/>
            <UserPasswordEditDialog show={showModal2} handleClose={handleClose} id={showModelId}/>
            <AuditHistoryDialog show={showAuditHistoryModal} handleClose={handleClose} id={showModelId}/>
        </>
    );
}
